module.exports = __webpack_public_path__ + "img/icons.41e0e895.png";